module.exports = __webpack_public_path__ + "static/text-61fc1321306681e8b169eda0ba24c3ad.png";